var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMaleIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 50,
  fill: "none",
  viewBox: "0 0 24 50",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#BCBCBC",
  d: "M16.447 5.361a4.861 4.861 0 1 1-9.722 0 4.861 4.861 0 0 1 9.722 0ZM3.026 12.637h18.428l.228.023a2.013 2.013 0 0 1 1.818 2v14.692h-.005v.5a1.754 1.754 0 1 1-3.508 0v-.5h-.024V19.247a1.22 1.22 0 1 0-2.44 0v27.796a2.138 2.138 0 0 1-4.274 0V32.548h-.115a1.232 1.232 0 0 0-2.268 0h-.115V47.05a2.136 2.136 0 0 1-4.274.003V18.746h-.125a1.21 1.21 0 0 0-1.095-.69h-.001a1.22 1.22 0 0 0-1.094.69h-.125v10.605h-.005v.5a1.753 1.753 0 1 1-3.507 0v-.5H.5V14.933l.002-.269a2.024 2.024 0 0 1 2.024-2.01h.5z"
})));
export { SvgMaleIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/maleIcon.svg";